module.exports = __webpack_public_path__ + "img/revexpo_1961.88c24910.jpg";